import Favicon from "../../images/Favicon.svg";
import LanguageSwitch from "../LanguageSwitch/LanguageSwitch";
import { PublicPortalHeaderSkeleton } from "./PublicPortalSkeleton";

const PublicPortalHeader = ({
  assets,
  brand,
  isLoading = false,
  onLanguageChange,
  showLanguageSwitch,
}) => {
  if (isLoading) {
    return <PublicPortalHeaderSkeleton />;
  }

  return (
    <>
      <header
        className="w-full min-w-0 overflow-hidden border-b border-cfCardBorder"
        style={{
          backgroundColor: assets?.navbar_background_color,
          color: assets?.navbar_text_color,
        }}
      >
        <div className="flex w-full min-w-0 items-center justify-between gap-2 px-4 py-3 sm:px-8 lg:px-12">
          <div className="flex min-w-0 flex-1 items-center gap-2 sm:gap-3">
            <img
              className="h-10 w-auto max-w-[88px] shrink-0 object-contain sm:h-12 sm:max-w-[180px]"
              src={assets?.navbar_logo || Favicon}
              alt={brand.name}
            />
            <div className="min-w-0">
              <p className="m-0 truncate text-base font-bold leading-tight sm:text-lg">
                {brand.name}
              </p>
              <p className="m-0 truncate text-xs opacity-70">{brand.subtitle}</p>
            </div>
          </div>

          {showLanguageSwitch && (
            <div className="shrink-0">
              <LanguageSwitch onLanguageChange={onLanguageChange} />
            </div>
          )}
        </div>
      </header>
    </>
  );
};

export default PublicPortalHeader;
